var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRepeat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#454650"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#262732",
  fillRule: "evenodd",
  d: "M12.188 5.195a.666.666 0 0 0-.947.006L7.165 9.377 5.148 7.261a.666.666 0 0 0-.964.92l2.49 2.613c.259.27.69.275.954.011l.001-.001.053-.05 4.512-4.623a.666.666 0 0 0-.006-.936",
  clipRule: "evenodd"
})));
export { SvgRepeat as ReactComponent };